import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["replyForm"]

  showReplyForm(event) {
    event.preventDefault()
    const commentId = event.currentTarget.dataset.commentId
    const replyForm = this.element.querySelector(`[data-comments-target="replyForm_${commentId}"]`)
    
    if (replyForm) {
      replyForm.classList.toggle('hidden')
    }
  }

  hideReplyForm(commentId) {
    const replyForm = this.element.querySelector(`[data-comments-target="replyForm_${commentId}"]`)
    if (replyForm) {
      replyForm.classList.add('hidden')
    }
  }
} 